// Importa useEffect per aggiungere l'event listener per il keydown
import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import "./ContactForm.css";
import { Img } from "react-image";
import logo from "../../assets/Nexum-Marchio.png";
import loader from "../../assets/nexumspinner.gif";
import DescriptionAlerts from "../../shared/components/Alert/AlertNotification";
import EmailIcon from '@mui/icons-material/Email';

interface ContactFormProps {
  setIsEmailFormVisible: (isVisible: boolean) => void;
  isTrial: boolean;
  trialEnded: boolean;
  setContactFormOpen: Function;
  subscription: string;
  dailyQuotaReached: boolean;
}

const ContactForm: React.FC<ContactFormProps> = ({
  setIsEmailFormVisible,
  trialEnded,
  setContactFormOpen,
  subscription,
  dailyQuotaReached,
}) => {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(false);
  const [severity, setSeverity] = useState<
    "success" | "info" | "warning" | "error" | undefined
  >("success");
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    message: "",
    telephone: "",
    userType: "",
  });
  const [errors, setErrors] = useState({
    name: false,
    surname: false,
    email: false,
    message: false,
    telephone: false,
    userType: false,
  });
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== "Backspace" && isNaN(Number(e.key))) {
        e.preventDefault();
      }
    };
    document
      .getElementById("telephone")
      ?.addEventListener("keydown", handleKeyDown);

    return () => {
      document
        .getElementById("telephone")
        ?.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleBack = () => {
    setIsEmailFormVisible(!setIsEmailFormVisible);
    setContactFormOpen(false);
  };

  const handleEmailClick = () => {
    window.open(
      "mailto:nexbot_support@nexum-ai.com?subject=Informazioni&body=Ciao%20sono%20interessato%20a:"
    );
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    let formValid = true;
    const newErrors = {
      name: !formData.name,
      surname: !formData.surname,
      email: !formData.email || !/\S+@\S+\.\S+/.test(formData.email),
      message: trialEnded === false && !formData.message,
      telephone: trialEnded && !formData.telephone,
      userType: trialEnded && !formData.userType,
    };

    for (const key in newErrors) {
      if (newErrors[key as keyof typeof newErrors]) {
        formValid = false;
      }
    }

    setErrors(newErrors);

    if (formValid) {
      setLoading(true);
      const formDataWithChatId = {
        ...formData,
        chatId: sessionStorage.getItem("chatId") || "",
        uid: sessionStorage.getItem("uid") || "",
        button_type: trialEnded ? "trial over" : "support",
      };

      // EMAIL SEND
      emailjs
        .send(
          "service_s0p6ri8",
          "template_pgxwync",
          formDataWithChatId,
          "VXk0j-L6BcYJ4mPpP"
        )
        .then((response: any) => {
          setFormData({
            name: "",
            surname: "",
            email: "",
            message: "",
            telephone: "",
            userType: "",
          });
          setNotification(true);
          setSeverity("success");
          setTimeout(() => {
            setLoading(false);
            setNotification(false);
            setSeverity("info");
            {
              !trialEnded && setIsEmailFormVisible(false);
            }
          }, 2000);

          if (trialEnded) {
            setNotification(true);
            setSeverity("success");
            setTimeout(() => {
              window.location.reload();
              window.sessionStorage.clear();
              window.localStorage.clear();
            }, 2000);
          }
          // API POST
          fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/saveData`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formDataWithChatId),
          })
            .then((apiResponse) => {})
            .catch((apiError) => {
              console.error("API call error:", apiError);
            });
        })
        .catch((error: any) => {
          setNotification(true);
          setSeverity("error");
          setTimeout(() => {
            setNotification(false);
            setLoading(false);
          }, 2000);

          setLoading(false);
          console.error("Email send failed:", error);
        });
    }
  };
  return (
    <>
      <div className="header-container-form">
        {loading && (
          <Img
            src={loader}
            style={{ width: "11em", position: "absolute", marginTop: "32em" }}
          />
        )}
        <Img src={logo} style={{ bottom: "0", left: "0", width: "6em" }} />
        {trialEnded && (
          <h1 style={{ color: "rgb(41, 73, 146)", fontFamily: "inherit" }}>
            The trial is over, Contact us!
          </h1>
        )}
        {!trialEnded && subscription === "Expired" && (
          <h1 style={{ color: "rgb(41, 73, 146)", fontFamily: "inherit" }}>
            Your Subscription Expired. Contact us or renew it from the SaaS portal
          </h1>
        )}
        {!trialEnded && subscription === "Basic" && dailyQuotaReached && (
          <h1 style={{ color: "rgb(41, 73, 146)", fontFamily: "inherit" }}>
            Your daily quota has been reached. Contact us or upgrade your plan
          </h1>
        )}
        {!trialEnded && subscription === "Pro" && dailyQuotaReached && (
          <h1 style={{ color: "rgb(41, 73, 146)", fontFamily: "inherit" }}>
            Your daily quota has been reached. Contact us or upgrade your plan
          </h1>
        )}
        {!trialEnded && !dailyQuotaReached && (
          <h1 style={{ color: "rgb(41, 73, 146)", fontFamily: "inherit" }}>
            Contact us
          </h1>
        )}
      </div>
      {severity && notification === true && (
        <DescriptionAlerts severity={severity} uploadSuccess={false} />
      )}
      <div className={"form-container"}>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="hidden"
            name="chatId"
            value={sessionStorage.getItem("chatId") || ""}
          />
          <div>
            <label className="label" htmlFor="name">
              Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? "error" : ""}
            />
            {errors.name && (
              <span className="errorMessage">Required field!</span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="surname">
              Surname:
            </label>
            <input
              type="text"
              id="surname"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              className={errors.surname ? "error" : ""}
            />
            {errors.surname && (
              <span className="errorMessage">Required field!</span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="email">
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? "error" : ""}
            />
            {errors.email && (
              <span className="errorMessage">Required field!</span>
            )}
          </div>
          {trialEnded === false && (
            <div>
              <label className="label" htmlFor="message">
                Description:
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className={errors.message ? "error textbase" : "textbase"}
              />
              {errors.message && (
                <span className="errorMessage">Required field!</span>
              )}
            </div>
          )}
          {trialEnded && (
            <>
              <div>
                <label className="label" htmlFor="telephone">
                  Telephone Number:
                </label>
                <input
                  type="text"
                  id="telephone"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  className={errors.telephone ? "error" : ""}
                />
                {errors.telephone && (
                  <span className="errorMessage">Required field!</span>
                )}
              </div>
              {trialEnded && (
                <div>
                  <label className="label" htmlFor="userType">
                    User Type:
                  </label>
                  <select
                    id="userType"
                    name="userType"
                    value={formData.userType}
                    onChange={handleChange}
                    className={errors.userType ? "error" : ""}
                  >
                    <option value="">Select User Type</option>
                    <option value="individual User">Individual user</option>
                    <option value="employee">Employee</option>
                    <option value="professional">Professional</option>
                    <option value="company ">Company </option>
                    <option value="other">Other</option>
                  </select>
                  {errors.userType && (
                    <span className="errorMessage">Required field!</span>
                  )}
                </div>
              )}
            </>
          )}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button className="sendButton" type="submit">Send</button>
            {!trialEnded && !dailyQuotaReached && subscription !== "Expired" && (
              <button
               className="backButton"
                onClick={() => handleBack()}
                type="button"
              >
                Back
              </button>
            )}
          </div>
          <h3 style={{color: "white"}}>Support:</h3>
          <div style={{display: "flex", flexDirection: "row"}}>
            <EmailIcon style={{color: "white"}}/>
            <p style={{color: "white", cursor: "pointer"}} onClick={handleEmailClick}>&nbsp;nexbot_support@nexum-ai.com</p>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
